import { render, staticRenderFns } from "./AdministrationInput.vue?vue&type=template&id=5fa41c1e"
import script from "./AdministrationInput.vue?vue&type=script&lang=js"
export * from "./AdministrationInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports